var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpaceship = function SvgSpaceship(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 456,
    viewBox: "0 0 261 456",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2114_43648)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -38,
    cy: 259,
    rx: 274,
    ry: 401,
    fill: "url(#paint0_linear_2114_43648)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.45453,
    y: 430.242,
    width: 222.643,
    height: 72.4259,
    fill: "url(#paint1_linear_2114_43648)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1731 425.897C90.8824 411.207 93.0361 305.83 92.3543 292.939C94.0384 292.96 98.4583 292.889 102.5 292.939C100.475 347.39 102.205 394.594 103.5 425.897C100.693 425.862 94.2358 425.973 88.1731 425.897Z",
    fill: "url(#paint2_linear_2114_43648)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 430C108.684 415.236 109.579 305.919 108.684 293H119.421C117.99 347.627 121.211 398.626 123 430H106Z",
    fill: "url(#paint3_linear_2114_43648)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.3745,
    y: 290.73,
    width: 12.7935,
    height: 3.19838,
    rx: 0.799596,
    fill: "url(#paint4_linear_2114_43648)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.166,
    y: 290.73,
    width: 12.7935,
    height: 3.19838,
    rx: 0.799596,
    fill: "url(#paint5_linear_2114_43648)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5769 189.341C86.5769 180.929 89.2844 172.74 94.2989 165.986L101.031 156.918C103.589 153.473 108.745 153.473 111.303 156.918L118.035 165.986C123.05 172.74 125.757 180.929 125.757 189.341V288.73C125.757 290.055 124.683 291.129 123.358 291.129H88.9757C87.6509 291.129 86.5769 290.055 86.5769 288.73V189.341Z",
    fill: "url(#paint6_linear_2114_43648)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.758 201.689C130.513 217.979 129.981 224.23 138.248 232.359C151.665 245.553 164.235 258.746 164.235 267.941C164.235 271.302 164.235 274.056 164.235 276.198C164.235 279.289 161.729 281.792 158.638 281.792L125.757 281.791L125.758 201.689Z",
    fill: "url(#paint7_linear_2114_43648)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5765 201.451C81.8207 217.741 82.9474 223.992 74.6805 232.121C61.2632 245.315 48.6936 258.508 48.6936 267.703C48.6936 271.063 48.6936 273.817 48.6936 275.959C48.6936 279.051 51.1997 281.554 54.291 281.554L86.5769 281.553L86.5765 201.451Z",
    fill: "url(#paint8_linear_2114_43648)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.536 178.085C103.14 178.085 100.321 180.624 98.3962 182.74C97.8956 183.29 97.0359 182.953 97.1549 182.219C97.7843 178.337 100.18 173.188 106.536 173.188C112.875 173.188 114.925 178.31 115.297 182.189C115.368 182.932 114.47 183.219 113.992 182.645C112.246 180.549 109.622 178.085 106.536 178.085Z",
    fill: "url(#paint9_linear_2114_43648)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.168,
    y: 248.352,
    width: 3.99798,
    height: 36.7814,
    rx: 1.99899,
    fill: "url(#paint10_linear_2114_43648)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.8528,
    cy: 429.444,
    r: 21.3073,
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.0294,
    cy: 416.659,
    r: 21.3073,
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.0294,
    cy: 440.096,
    r: 21.3073,
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.8528,
    cy: 429.444,
    r: 21.3073,
    fill: "url(#paint11_linear_2114_43648)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5328,
    cy: 428.379,
    r: 15.9805,
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.455,
    cy: 436.902,
    r: 20.242,
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.3632,
    cy: 432.64,
    r: 24.5034,
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.3632,
    cy: 432.64,
    r: 24.5034,
    fill: "url(#paint12_linear_2114_43648)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.547,
    cy: 436.902,
    r: 24.5034,
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.508,
    cy: 424.116,
    r: 28.7649,
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.547,
    cy: 436.902,
    r: 24.5034,
    fill: "url(#paint13_linear_2114_43648)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -10.8182,
    cy: 460.092,
    r: 27.1818,
    fill: "url(#paint14_linear_2114_43648)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.4091,
    cy: 32.4091,
    r: 32.4091,
    transform: "matrix(-1 0 0 1 261 426.637)",
    fill: "url(#paint15_linear_2114_43648)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 39.5,
    r: 1.5,
    fill: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 44,
    cy: 67,
    r: 1,
    fill: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 175.5,
    cy: 88.5,
    r: 1.5,
    fill: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 123.5,
    cy: 102.5,
    r: 1.5,
    fill: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 83,
    cy: 82,
    r: 2,
    fill: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 28,
    cy: 121,
    r: 1,
    fill: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 199,
    cy: 67,
    r: 1,
    fill: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 86,
    r: 2,
    fill: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 31,
    r: 2,
    fill: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 9,
    r: 1,
    fill: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 25,
    r: 1,
    fill: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 133.5,
    cy: 62.5,
    r: 1.5,
    fill: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 205.5,
    cy: 130.5,
    r: 1.5,
    fill: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 140,
    cy: 139,
    r: 2,
    fill: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 68,
    cy: 147,
    r: 2,
    fill: "#8C9EFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2114_43648",
    x1: -148.5,
    y1: 27.5,
    x2: 204.5,
    y2: 439.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002EAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2979FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2114_43648",
    x1: 110.455,
    y1: 455.908,
    x2: 110.455,
    y2: 495.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F4FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2114_43648",
    x1: 88.8749,
    y1: 369.516,
    x2: 95.9065,
    y2: 369.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#D5EAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2114_43648",
    x1: 106,
    y1: 369.832,
    x2: 113.473,
    y2: 369.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5EAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2114_43648",
    x1: 95.7723,
    y1: 289.931,
    x2: 94.7716,
    y2: 298.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2979FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2114_43648",
    x1: 112.564,
    y1: 289.931,
    x2: 111.563,
    y2: 298.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2979FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2114_43648",
    x1: 86.5769,
    y1: 216.766,
    x2: 103.768,
    y2: 217.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2114_43648",
    x1: 113.763,
    y1: 253.149,
    x2: 154.246,
    y2: 250.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2114_43648",
    x1: 98.6771,
    y1: 252.823,
    x2: 58.6328,
    y2: 249.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2114_43648",
    x1: 98.5709,
    y1: 177.185,
    x2: 122.482,
    y2: 188.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2979FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2114_43648",
    x1: 104.766,
    y1: 265.239,
    x2: 108.51,
    y2: 265.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2114_43648",
    x1: 12.8528,
    y1: 408.137,
    x2: 12.8528,
    y2: 450.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2114_43648",
    x1: 92.3632,
    y1: 408.137,
    x2: 92.3632,
    y2: 457.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2114_43648",
    x1: 160.547,
    y1: 412.398,
    x2: 160.547,
    y2: 461.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2114_43648",
    x1: -10.8182,
    y1: 432.91,
    x2: -32.7727,
    y2: 470.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2114_43648",
    x1: 32.4091,
    y1: 0,
    x2: 6.23252,
    y2: 44.8741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2114_43648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261,
    height: 456,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpaceship);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "spaceship.bc3dd5f84fdc4c2bc8a7e01d138d9c28.svg";